import { fetchAllHydraMembers as fetchAllHydraMembersWithClient } from "src/api/_common/hydra/fetchAllHydraMembers";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CollectionParams = Record<string, boolean | number | string | undefined>;

export const fetchAllHydraMembers = async (
    endpoint: string,
    params: CollectionParams = {},
    itemsPerPage = 100,
): Promise<unknown[]> =>
    await fetchAllHydraMembersWithClient({
        client: loggedInApiCall,
        endpoint,
        itemsPerPage,
        params,
    });
